import React from "react";

class Button extends React.Component {

    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.jsonForEvaluation = this.jsonForEvaluation.bind(this);
    }

    jsonForEvaluation() {
        const result = {
            question: this.props.question,
            answer: this.props.answer,
            rating: this.props.rating
        }
        return JSON.stringify(result).toString();
    }

    handleChange(e) {
        this.props.setAnswered();

        const summaryItem = {
            identifier: this.props.isMultiple ? this.props.childrenIdentifier : e.target.dataset.summaryidentifier,
            categorize: e.target.dataset.summarycategorize,
            toRemove: !e.target.checked && e.target.type === 'checkbox'
        };

        this.props.updateSummary(summaryItem)
    }

    render() {
        return (
            <>
                <div className="form-check">
                    {!this.props.isMultiple &&
                        <input className="form-check-input select-button" type="radio" data-unique="1"
                               data-summaryidentifier={this.props.identifier}
                               data-summarycategorize={this.jsonForEvaluation()}

                               data-identifier={this.props.identifier} name={'field_' + this.props.identifier} id={'check_' + this.props.id} onChange={this.handleChange} />
                    }
                    {this.props.isMultiple &&
                        <input className="form-check-input select-button" type="checkbox" data-unique="0"
                               data-summaryidentifier={this.props.identifier}
                               data-summarycategorize={this.jsonForEvaluation()}

                               data-identifier={this.props.identifier} name={'field_' + this.props.identifier} value="1" id={'check_' + this.props.id} onChange={this.handleChange} />
                    }
                    <label className="form-check-label" htmlFor={'check_' + this.props.id} >
                        {this.props.children}
                    </label>
                </div>
            </>
        );
    }
}

export default Button;
